import { useState } from 'react'

import adminCss from './sass/adminpage.module.scss'
import themeCss from '../components/sass/theme.module.scss'

import ItemDisplay from './ItemDisplay'
import { isAuctionOwner } from './permissionsutil'
import StatSummary from './StatSummary'
import AdminDonations from './AdminDonations'
import ReportButton from './ReportButton'
import ItemListGenerateButton from './ItemListGenerateButton'
import ItemOrderArrangePanel from './ItemOrderArrangePanel'

export default function AdminAuctionItems(props) {

  const [sortedItems, setSortedItems] = useState()
  const [sortedFixedItems, setSortedFixedItems] = useState()
  const [showItemOrderArrangePanel, setShowItemOrderArrangePanel] = useState(false)

  const isPreview = props.auction?.Status === 'PREVIEW'

  const isUserSR = localStorage.getItem('isSolicitationReviewAdmin')

  console.log('props', props)


  //for the copy to clipboard, and the mapping of table headers with functions
  let tableFormatter = [
    ['Title', 'Item Title'],
    ['Category', 'Category'],
    ['BidCount', 'Bid Count'],
    ['CurrentBid', 'Current Bid'],
    ['BidderFullName', 'Current High Bidder'],
    ['Value', 'Fair Market Value'],
    ['StartingBid', 'Starting Bid'],
    ['MinRaise', 'Min. Raise'],
    ['Paid', 'Paid?'],
  ]

  let fixedTableFormatter = [
    ['Title', 'Item Title'],
    ['Category', 'Category'],
    ['TotalItemsAvailable', 'Total Amount Available'],
    ['TotalItemsPurchased', 'Amount Purchased'],
    ['TotalItemsRemaining', 'Amount Remaining'],
    ['PurchasePrice', 'Purchase Price'],
    ['Value', 'Fair Market Value'],
    ['TotalRaised', 'Total Money Raised'],
    ['CurrentBuyers', 'Current Buyers']
  ]

  if (isUserSR) {
    tableFormatter = [
      ['Title', 'Item Title'],
      ['Description', 'Description'],
      ['Value', 'Fair Market Value'],
      ['StartingBid', 'Starting Bid'],
      ['MinRaise', 'Min. Raise'],
    ]

    fixedTableFormatter = [
      ['Title', 'Item Title'],
      ['Description', 'Description'],
      ['TotalItemsAvailable', 'Total Amount Available'],
      ['PurchasePrice', 'Purchase Price'],
      ['Value', 'Fair Market Value'],
    ]
  }

  function sanitizeForExcel(str) {
    if (!str) return '';
    return str
      .replace(/\r?\n|\r/g, ' ')   // replace newlines with spaces
      .replace(/\t/g, ' ');        // replace tab characters with spaces
  }


  // make sure to update this if the columns change
  const copyItemsToClipboard = () => {
    const textToCopy = [tableFormatter.map(headerName => headerName[1]).join('\t')];
    sortedItems.forEach(row => {
      const rowToPush = tableFormatter.map((column) => {
        if (column[0] === 'Paid') return row[column[0]] ? 'Yes' : 'No'
        if (column[0] === 'Description') return sanitizeForExcel(row[column[0]])
        else return row[column[0]]
      })
      textToCopy.push(rowToPush.join('\t'))
    })
    //formatting for the fixed items
    textToCopy.push([fixedTableFormatter.map(headerName => headerName[1]).join('\t')])
    sortedFixedItems.forEach(row => {
      const rowToPush = fixedTableFormatter.map((column) => {
        if (column[0] === 'TotalItemsAvailable') return row[column[0]] ? row[column[0]] : 'Unlimited'
        if (column[0] === 'TotalItemsRemaining') {
          if (row.TotalItemsRemaining === 0) return 'Sold Out'
          else return row.TotalItemsRemaining ? row.TotalItemsRemaining : 'Unlimited'
        }
        if (column[0] === 'TotalRaised') return row?.adminSummary?.Totals?.AmountRaised
        if (column[0] === 'CurrentBuyers') return row?.adminSummary?.Totals?.BuyerCount
        if (column[0] === 'Description') return sanitizeForExcel(row[column[0]])
        else return row[column[0]]
      })
      textToCopy.push(rowToPush.join('\t'))
    })
    navigator.clipboard.writeText(textToCopy.join('\n'))
  }

  if (!props.auction)
    return

  if (showItemOrderArrangePanel) {
    return (
      <ItemOrderArrangePanel
        auction={props.auction}
        refreshAdminAuctionQuery={props.refreshAdminAuctionQuery}
        toAllItemsAndDonations={() => setShowItemOrderArrangePanel(false)}
      />
    )
  }

  return (
    <div>
      <div className={adminCss['admin-auction-items-title']}>      
        <h3 className={adminCss['admin-auction-page-tab-header']}>
          Auction Items
        </h3>

        <ItemListGenerateButton auction={props.auction} />        
        {props.hasEnded && <ReportButton auction={props.auction} />}

        <StatSummary auction={props.auction} />
      </div>

      {props.auction.Items.length !== 0 &&
        <div className={adminCss['admin-auction-items-notices']}>
          {isPreview ? <></> : <p className={themeCss['boldGreen']}>Items in bold green are above Fair Market Value:</p>}
          <p>After an item receives a bid, you can click on the Bid Count to view the item's entire Bid History.</p>
          <p>You can click on the Current High Bidder's name to view the user's entire Bid History.</p>
          <p>You can click on the Link icon under Actions to copy the individual item's link to your clipboard.</p>
          {!props.hasEnded && <p>You can click on <b>Arrange Display Order</b> to arrange the order that all items will display in the auction page to the attendees. This will not change the order seen on this page, only what the attendee sees.</p>}
          {props.hasEnded && isAuctionOwner(props.auction) && <p>You can go to the <b>View Attendees</b> tab to Manage Checkout for an individual attendee.</p>}
        </div>
      }

      <ItemDisplay selectedAuction={props.auction} refreshAdminAuctionQuery={props.refreshAdminAuctionQuery} 
        hasEnded={props.hasEnded} sortedItems={sortedItems} setSortedItems={setSortedItems}
        sortedFixedItems={sortedFixedItems} setSortedFixedItems={setSortedFixedItems}
        tableFormatter={tableFormatter} isUserSR={isUserSR} fixedTableFormatter={fixedTableFormatter}
        onArrangeDisplayOrder={() => setShowItemOrderArrangePanel(true)}
      />
      
      {/* commenting it out, in case solicitation review wants it again
      {(props.hasEnded || isUserSR) && <button className={`${themeCss['button']} ${themeCss['FilledWhite']} ${themeCss['copyclipboard-button']}`} onClick={copyItemsToClipboard}>
        Copy Data to Clipboard
      </button>} */}

      <AdminDonations auction={props.auction} refreshAdminAuctionQuery={props.refreshAdminAuctionQuery}/>
    </div>
  )
}
